if (!customElements.get("quick-add-modal")) {
  customElements.define(
    "quick-add-modal",
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);

        const sizeChartPopup = document.getElementById("size-chart-popup-");
        if (sizeChartPopup && !this.modalContent.contains(sizeChartPopup)) sizeChartPopup.remove();

        this.modalContent.innerHTML = "";

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      // The drawer's own layout/typography (assets/quick-add-content.css)
      // and its full-PDP-lookalike scoped clone (assets/quick-add-modal-
      // scoped.css, used by a couple of components rendered inside the
      // fetched content that still expect shop-product-details.css's
      // rules) are both loaded here, on open, not as site-wide asset tags.
      loadScopedStyles() {
        const href = this.dataset.scopedCssUrl;
        if (!href) return;
        if (document.querySelector(`link[href="${href}"]`)) return;
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
      }

      loadDrawerStyles() {
        const href = this.dataset.drawerCssUrl;
        if (!href) return;
        if (document.querySelector(`link[href="${href}"]`)) return;
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = href;
        document.head.appendChild(link);
      }

      // snippets/size-chart-block.liquid's own click wiring lives inside a
      // <script> wrapped in document.addEventListener('DOMContentLoaded',
      // ...) - already fired long before this content is fetched and
      // injected here, so it never runs and the "Maatgids" trigger does
      // nothing. Re-wired manually instead of editing that shared snippet
      // (used elsewhere with its DOMContentLoaded wiring intact and
      // working normally on a real page load).
      initSizeChart() {
        // A previous open already moved its popup out to document.body
        // (see below) - remove it before wiring up the freshly injected
        // one, since block.id is always blank here (no configured block
        // instance), so the popup id is always the literal same string
        // and a stale copy would shadow the new one.
        const stalePopup = document.getElementById("size-chart-popup-");
        if (stalePopup && !this.modalContent.contains(stalePopup)) stalePopup.remove();

        const trigger = this.modalContent.querySelector("[data-size-chart-popup]");
        if (!trigger) return;
        const popup = document.getElementById(trigger.getAttribute("data-size-chart-popup"));
        if (!popup) return;
        const close = popup.querySelector(".size-chart-popup-close");
        const backdrop = popup.querySelector(".size-chart-popup-backdrop");

        document.body.appendChild(popup);

        const openChart = () => popup.classList.add("active");
        const closeChart = () => popup.classList.remove("active");

        trigger.addEventListener("click", openChart);
        if (close) close.addEventListener("click", closeChart);
        if (backdrop) backdrop.addEventListener("click", closeChart);
      }

      show(opener) {
        this.loadScopedStyles();
        this.loadDrawerStyles();
        opener.setAttribute("aria-disabled", true);
        opener.classList.add("loading");
        opener.querySelector(".loading__spinner").classList.remove("hidden");

        // Fetches sections/quick-add-content.liquid via Shopify's Section
        // Rendering API instead of the whole product page: a purpose-built
        // compact fragment (photo column + info column) rather than the
        // full PDP (gallery + description + accordions + reviews), which
        // is what used to make this modal look like an unfinished full
        // product page (fixed 2026-08-19).
        const productUrl = opener.getAttribute("data-product-url");
        const separator = productUrl.indexOf("?") === -1 ? "?" : "&";
        const quickAddUrl = `${productUrl}${separator}section_id=quick-add-content`;

        fetch(quickAddUrl)
          .then((response) => response.text())
          .then((responseText) => {
            HTMLUpdateUtility.setInnerHTML(this.modalContent, responseText);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            this.initSizeChart();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute("aria-disabled");
            opener.classList.remove("loading");
            opener.querySelector(".loading__spinner").classList.add("hidden");
          });
      }
    },
  );
}
